/* eslint-disable import/no-anonymous-default-export */
const options = (method, Authorization, bodyData) => {
  const headers = { 'Content-Type': 'application/json' }
  headers.Authorization = 'Bearer ' + Authorization;
  headers.Canal = global.CANAL
  let requestOptions;
  if (method === "POST") {
    requestOptions = {
      method: method,
      headers,
      body: JSON.stringify(bodyData)
    }
  } else {
    requestOptions = {
      method: method,
      headers
    }
  }
  return requestOptions
}

export default {
  options
}